<template>
  <div class="" testek="product-detail">
    <div class="header"></div>
    <BaseDetail
      @viewDetail="viewDetail"
      @addData="addData"
      @addMoreData="addMoreData"
      :currentItem="currentItem"
      :titleDetail="$t('i18nCommon.TitleShipperId')"
    >
      <template #header>
        <div class="font-bold text-xl mb-4">
          {{ title }}
        </div>
      </template>
      <template #content>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <a-form-item
                prop="Id"
                testek="Id"
                class="columns-1 w-full"
                v-if="mode == $enum.Mode.Edit"
              >
                <div class="flex w-full">
                  <div class="flex min-w-32 font-bold">ID</div>
                  <a-input v-model:value="ruleForm.id" />
                </div>
              </a-form-item>
              <div class="flex columns-2">
                <a-form-item prop="name" testek="name" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Name") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.name" />
                  </div>
                </a-form-item>
                <a-form-item prop="phoneNum" testek="phoneNum" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                    </div>
                    <a-input v-model:value="ruleForm.phoneNum" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="email" testek="email" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">Email</div>
                    <a-input v-model:value="ruleForm.email" />
                  </div>
                </a-form-item>
                <a-form-item prop="contact" testek="Contact" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Contact") }}
                    </div>
                    <a-input v-model:value="ruleForm.contact" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="conutry" testek="conutry" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Conutry") }}
                    </div>
                    <a-input v-model:value="ruleForm.conutry" />
                  </div>
                </a-form-item>
                <a-form-item prop="city" testek="city" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.City") }}
                    </div>
                    <a-input v-model:value="ruleForm.city" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="address" testek="address" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Address") }}
                    </div>
                    <a-input v-model:value="ruleForm.address" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="postalCode" testek="postalCode" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.PostalCode") }}
                    </div>
                    <a-input v-model:value="ruleForm.postalCode" />
                  </div>
                </a-form-item>
              </div>
              <a-form-item class="mt-6">
                <div class="flex">
                  <a-button
                    type="primary"
                    testek="btn-add"
                    @click="submitForm()"
                    class="mr-4"
                  >
                    {{ $t("i18nCommon.Add") }}
                  </a-button>
                  <a-button type="primary" testek="btn-add-more" @click="addMoreData()">
                    {{ $t("i18nCommon.AddMore") }}
                  </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </template>
    </BaseDetail>
    <div v-if="isShow && shipper">
      <a-modal v-model:open="isShow" centered :width="800" :closable="false">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Shipper") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="shipper"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              status-icon
            >
              <div class="flex columns-2">
                <a-form-item prop="name" testek="name" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Name") }}
                    </div>
                    <a-input v-model:value="shipper.name" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item
                  :label="$t('i18nProduct.Phone')"
                  prop="phoneNum"
                  testek="phoneNum"
                  class="w-full"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                    </div>
                    <a-input v-model:value="shipper.phoneNum" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="email" testek="email" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">Email</div>
                    <a-input v-model:value="shipper.email" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="contact" testek="Contact" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Contact") }}
                    </div>
                    <a-input v-model:value="shipper.contact" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="conutry" testek="conutry" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Conutry") }}
                    </div>
                    <a-input v-model:value="shipper.conutry" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="city" testek="city" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.City") }}
                    </div>
                    <a-input v-model:value="shipper.city" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="address" testek="address" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Address") }}
                    </div>
                    <a-input v-model:value="shipper.address" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="postalCode" testek="postalCode" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.PostalCode") }}
                    </div>
                    <a-input v-model:value="shipper.postalCode" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import BaseDetail from "@/views/base/BaseDetail.vue";
import { mapActions } from "vuex";
import { ModuleShipper } from "@/store/module-const";
import _ from "lodash";
export default {
  name: "ShipperDetail",
  components: {
    BaseDetail,
  },
  props: {
    mode: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    title() {
      if (this.mode == this.$enum.Mode.Edit) return this.$t("i18nCommon.EditShipper");
      return this.$t("i18nCommon.AddShipper");
    },
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      currentItem: {},
      shipper: {},
      isShow: false,
    };
  },
  created() {
    const me = this;
    me.initDataStatic();
  },
  methods: {
    ...mapActions(ModuleShipper, ["getShipper", "createShipper"]),
    initDataStatic() {
      const me = this;
      me.rules = {
        name: [
          {
            required: true,
            message: `${me.$t("i18nProduct.NameInvalid")}`,
            trigger: "blur",
          },
        ],
      };
    },
    async submitForm(isReset = true) {
      const me = this;
      let formEl = me.$refs.ruleFormRef;
      if (!formEl) return;

      formEl
        .validate()
        .then(() => {
          me.addData(isReset);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    addMoreData: _.debounce(async function () {
      const me = this;
      await me.submitForm(false);
    }, 300),
    addData: _.debounce(async function (isReset = true) {
      const me = this;
      let result = await me.createShipper(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddShipperSuccess")
        );
        if (isReset == true) {
          me.ruleForm = {};
        }
        // me.$router.push("/product");
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddShipperFail"),
          "warning"
        );
      }
    }, 300),

    viewDetail: _.debounce(async function (params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.shipper = await me.getShipper({ id: params.id });
      if (me.shipper) {
        me.isShow = true;
      } else {
      }
      //Show form chi tiết
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
